import { render, staticRenderFns } from "./PlatformAdmin.vue?vue&type=template&id=bada804e&scoped=true&"
import script from "./PlatformAdmin.vue?vue&type=script&lang=js&"
export * from "./PlatformAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PlatformAdmin.vue?vue&type=style&index=0&id=bada804e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bada804e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
